export default "__VITE_ASSET__8yhuJ6Qf__"